/**
 * 移除所有子节点
 *
 * @param el 父节点
 */
export const removeChildren = (el: HTMLElement | null | undefined) => {
  if (!el) return
  while (el.firstChild) {
    el.removeChild(el.firstChild)
  }
}

/**
 * 判断是否滚动到底部
 */
export const isScrollEnd = (el: HTMLElement) => {
  return el.scrollHeight - el.scrollTop - el.clientHeight <= 80
}

const hasOverflow = (
  el: HTMLElement,
  types: 'scroll' | 'auto' | 'hidden' | 'visible'[]
) => {
  const overflow = window.getComputedStyle(el).overflow
  return types.includes(overflow as any)
}

/**
 * 获取第一个产生滚动条的父节点
 *
 * @param el
 * @returns
 */
export const getFirstScrolledParent = (el: HTMLElement) => {
  let parent = el.parentElement

  while (parent) {
    // Check for vertical scrolling
    if (
      parent.scrollHeight > parent.clientHeight &&
      hasOverflow(parent, 'auto')
    ) {
      return parent === document.documentElement ? document.body : parent
    }
    parent = parent.parentElement
  }

  return document.body
}

/**
 * 查找父元素
 */
export const findParentElement = <T extends HTMLElement>({
  target,
  root,
  $predicate
}: {
  target: HTMLElement
  root?: HTMLElement | null
  $predicate: (element: HTMLElement) => element is T
}) => {
  let current: HTMLElement | null = target
  while (current) {
    if ($predicate(current)) {
      return current
    }
    if (current === root) {
      return null
    }
    current = current.parentElement
  }
  return null
}

/**
 * 判断是否是HTML元素
 */
export const isHTMLElement = (
  target: EventTarget | null
): target is HTMLElement => {
  if (!target) {
    return false
  }
  return (
    target instanceof HTMLElement ||
    ('nodeType' in target && target.nodeType === Node.ELEMENT_NODE)
  )
}

/**
 * 计算 https://developer.mozilla.org/en-US/docs/Web/CSS/zoom
 *
 * TODO: 按照 lexical 的方式来实现
 */
export const calculateZoomLevel = (element: HTMLElement) => {
  return 1
}
